export default class ScriptLoader {
    static load(parent, file, type, id) {
        const parentTag = document.querySelector(parent);
        if(type === 'script'){ parentTag.appendChild(ScriptLoader.script(file, id)); }
        if(type === 'css'){ parentTag.appendChild(ScriptLoader.css(file)); }
    }

    static script(src, id){
        const el = document.createElement('script');
        el.type = 'text/javascript';
        el.src = src;
        el.id = id;
        return el;
    }

    static css(href){
        const el = document.createElement('link');
        el.type = 'text/css';
        el.href = href;
        el.rel = 'stylesheet';
        return el;
    }
}

window.loadScripts = ScriptLoader.load;